import { continents } from '@firebird-web/shared-constants';

// Europe and Asia write the day before the month ('20 Oct'), North America
// the other way round ('Oct 20').
export function isDayBeforeMonth(continent: string): boolean {
  return continent === continents.EUROPE || continent === continents.ASIA;
}

// 'Tue', in UTC.
export function formatChartWeekday(ms: number): string {
  return new Date(ms).toLocaleDateString('en-US', {
    weekday: 'short',
    timeZone: 'UTC',
  });
}

// 'Oct 20' or '20 Oct' by continent, in UTC.
export function formatChartMonthDay(ms: number, continent: string): string {
  const date = new Date(ms);
  const month = date.toLocaleDateString('en-US', {
    month: 'short',
    timeZone: 'UTC',
  });
  const day = date.getUTCDate();

  return isDayBeforeMonth(continent) ? `${day} ${month}` : `${month} ${day}`;
}

// 'Tue Oct 20' or 'Tue 20 Oct' by continent, in UTC.
export function formatChartDate(ms: number, continent: string): string {
  return `${formatChartWeekday(ms)} ${formatChartMonthDay(ms, continent)}`;
}
